export const DISCOUNT_COUPON_TYPE = {
  GLOBAL: "GLOBAL",
  TARGETED: "TARGETED",
};
